import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ContenutoGenericoService} from 'src/app/service/contenuto-generico.service';
import {ContenutoGenerico} from 'src/app/model/contenuto-generico';
import {Search} from 'src/app/common/search';
import {AllegatoService} from 'src/app/service/allegato.service';
import {Allegato} from 'src/app/model/allegato';
import {DocumentoService} from 'src/app/service/documento.service';
import {Documento} from 'src/app/model/documento';
import {manageErrorCode} from 'src/app/shared/manageErrorCode';
import {LazyLoadEvent, Message} from 'primeng/api';
import {Router} from '@angular/router';
import {DOCS_REPLACE, DOCS_REPLACE_NAME} from '../../constants/constants';
import { Table } from 'primeng/table';


@Component({
    selector: 'app-pages-with-uploads',
    templateUrl: './pages-with-uploads.component.html',
})
export class PagesWithUploadstComponent implements OnInit, OnChanges {

    @Input() element: ContenutoGenerico;
    msgs: Message[] = [];
    private _element: string;
    public allegato: Allegato;
    public componentiCollegati: Array<ContenutoGenerico>;
    public listSize = 10;
    public loading = true;
    private firstReload = true;
    public documenti: Documento[];
    public hasPaginator: boolean;
    public lingua: string;


    constructor(private contenutoService: ContenutoGenericoService,
                private documentoService: DocumentoService, protected router: Router,
                private allegatoService: AllegatoService) {
    }

    ngOnChanges(changes: SimpleChanges) {
        this.loaddata(this.firstReload);
    }

    ngOnInit() {
        this.lingua = this.element.lang;
    }

    public download(uuid_allegato: string) {
        this.allegatoService.find(uuid_allegato).subscribe(allegato => {
            this.allegato = allegato;
            if (allegato != null) {
                window.open(DOCS_REPLACE(allegato.uuid), '_blank');
            }
        });
    }

    public loaddata(firstReload: boolean, datatable?: any) {
        this.preLoaddata();
        this.contenutoService.getAllList().subscribe(componentiCollegati => {
                this.componentiCollegati = componentiCollegati;
                this.documentoService.search._sort = 'data_pubblicazione DESC, ora_pubblicazione DESC';
                this.documentoService.search._.tipologia = this.element.uuid;
                this.documentoService.search._.lang = this.lingua;
                this.documentoService.getList()
                    .subscribe(
                        model => {
                            this.documenti = model;
                            this.listSize = this.documentoService.listSize;
                            this.loading = false;
                        },
                        error => {
                            this.loading = false;
                            this.errorLoaddata(error);
                            manageErrorCode(error, this.msgs, this.router);
                        }
                    );
            },
            err => {
                this.loading = false;
            });
    }

    public preLoaddata() {
        this.contenutoService.search = new Search<ContenutoGenerico>(ContenutoGenerico);
        if (this.element) {
            this.lingua = this.element.lang;
            if (this.element.contenitore != null) {
                this.contenutoService.search._contains.contenitore = this.element.contenitore;
            } else {
                this.contenutoService.search._contains.contenitore = this.element.uuid;
            }
        }
        this.contenutoService.search._sort = 'ordine ASC';
        this.contenutoService.search._.lang = this.lingua;
        this.loading = true;
    }

    public errorLoaddata(error) {
        this.loading = false;
    }

    public lazyLoad(event: LazyLoadEvent, datatable?: any) {
        this.documentoService.search = new Search<Documento>(Documento);
        if (!this.firstReload) {
            this.documentoService.search._start = event.first;
        }
        this.documentoService.search._limit = event.rows;
        this.preLoad(event, datatable);
        this.loaddata(this.firstReload, datatable);
        if (this.firstReload) {
            this.firstReload = false;
        }
    }

    protected preLoad(event: LazyLoadEvent, datatable?: any) {
    }

    public refresh(datatable: Table) {
        this.clearMsgs();
        datatable.reset();
    }

    public reload(datatable: Table) {
        this.documentoService.search._start = 0;
        this.refresh(datatable);
    }

    public reset(datatable: Table) {
        this.documentoService.buildSearch();
        this.refresh(datatable);
    }

    public clearMsgs() {
        this.msgs = [];
    }

    path(uuid_allegato: string, titolo: string, estensione: string) {
        return DOCS_REPLACE_NAME(uuid_allegato, this.slug(titolo) + this.estensione(estensione));
    }


    estensione(estensione: string): string {
        switch (estensione) {
            case 'application/zip':
                return '.zip';
            case 'application/x-zip-compressed':
                return '.zip';
            case 'application/xhtml+xml':
                return '.xhtml';
            default:
                return '.pdf';
        }
    }

    slug(field: string) {
        if (field == null) {
            return null;
        }
        field = field.replace(/^\s+|\s+$/g, ''); // trim
        field = field.toLowerCase();
        return field.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-'); // collapse dashes
    }

}
